// "lastDetectionTime":0
// "numActiveSuspiciousTrails":null
// "numActiveThreatTrails":0
// "numAlertsGenerated":0
// "numEventsConsumed":0
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const alertAccountsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Name',
        label: 'Name',
        sortable: true,
        'min-width': 150,
        name: 'nickName'
      },
      {
        datatype: 'string',
        description: 'Type',
        label: 'Type',
        sortable: true,
        'min-width': 120,
        name: 'type',
        display: 'icon',
        displayKey: [
          { key: 'CB', icon: 'table-logos-icon logo-vmware-carbonblack-color' },
          { key: 'ALB', icon: 'table-logos-icon logo-aws-alb-color' },
          { key: 'PAN', icon: 'table-logos-icon logo-paloalto-networks-color' },
          { key: 'GUARDDUTY', icon: 'table-logos-icon logo-aws-guardduty-color' },
          { key: 'TRENDMICRO', icon: 'table-logos-icon logo-trendmicro-color' },
          { key: 'KUBERNETES', icon: 'table-logos-icon logo-kubernetes_color' },
          { key: 'SNYK', icon: 'table-logos-icon logo-snyk-color' },
          { key: 'RDS', icon: 'table-logos-icon logo-aws-rds-color' },
          { key: 'CLOUDTRAIL', icon: 'table-logos-icon logo-aws-cloudtrail-color' },
          { key: 'DEVO', icon: 'table-logos-icon logo-devo-color' },
          { key: 'CLOUDTRAIL_HISTORY', icon: 'table-logos-icon logo-aws-cloudtrail-history-color' },
          { key: 'AZURELOG', icon: 'table-logos-icon logo-azure-log-color' }
        ]
      },
      {
        datatype: 'string',
        description: 'Status',
        label: 'Status',
        sortable: true,
        'min-width': 150,
        name: 'status',
        display: 'component',
        component: 'IntegrationStatusTableCell',
        componentKey: 'status',
        componentFields: {
          status: 'status',
          assetCount: 'numContainers',
          accountType: 'type',
          accountKey: 'accountKey',
          nickName: 'nickName',
          assetText: 'containerText',
          lastScanTime: 'lastOperationTime',
          assetLink: {
            name: 'account-containers'
          }
        }
      },
      {
        datatype: 'string',
        description: 'Detections',
        label: 'Detections',
        sortable: true,
        'min-width': 150,
        name: 'numAlertsGenerated',
        display: 'link',
        pathTo: 'account-iocs',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'accountKey'
          },
          {
            name: 'nickName',
            keyLookup: 'nickName'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Progressions',
        label: 'Progressions',
        sortable: true,
        'min-width': 150,
        name: 'numActiveThreatTrails',
        display: 'link',
        pathTo: 'account-progressions',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'accountKey'
          },
          {
            name: 'nickName',
            keyLookup: 'nickName'
          }
        ]
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Last Detection Time',
        label: 'Last Detection Time',
        sortable: true,
        'min-width': 120,
        name: 'lastDetectionTime'
      }
    ]
  }
}

export { alertAccountsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/integration_accounts/alert-accounts.meta.js